const desc = `
  <body class="c0 doc-content">
    <p class="c3" dir="rtl">
      <span class="c2" style="font-style: italic; "> פתק בכתב ידה נמצא אחרי מותה בארון הספרים שלה. </span>
    </p>
  </body>
`;
export default desc;
